import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { Subject } from 'rxjs';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'income-form',
    templateUrl: './income-form.component.html',
    styleUrls: ['./income-form.component.scss'],
    standalone: false
})
export class IncomeFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  subscriptions: any[] = [];

  doneSubject: Subject<void> = new Subject<void>();
  page: number = 1;
  options2 = [
    { value: '1', label: 'Sans revenu', suffix: { title: 'A' } },
    { value: '2', label: '0 - 25 000€', suffix: { title: 'B' } },
    { value: '3', label: '25 000 - 50 000€', suffix: { title: 'C' } },
    { value: '4', label: '50 000 - 75 000€', suffix: { title: 'D' } },
    { value: '5', label: '75 000 - 100 000€', suffix: { title: 'E' } },
    { value: '6', label: '100 000 - 150 000€', suffix: { title: 'F' } },
    { value: '7', label: '150 000 - 300 000€', suffix: { title: 'G' } },
    { value: '8', label: '> 300 000€', suffix: { title: 'H' } },
  ];
  options: FormControlOption[] = [
    {
      value: 'BETWEEN_100K_AND_250K',
      label: 'Entre 100k€ et 250k€',
      suffix: { title: 'A' },
    },
    {
      value: 'BETWEEN_35K_AND_60K',
      label: 'Entre 35k€ et 60k€',
      suffix: { title: 'B' },
    },
    {
      value: 'BETWEEN_60K_AND_100K',
      label: 'Entre 60k€ et 100k€',
      suffix: { title: 'C' },
    },
    {
      value: 'GREATER_THAN_250K',
      label: 'Supérieur à 250k€',
      suffix: { title: 'D' },
    },
    {
      value: 'LESS_THAN_35K',
      label: 'Inférieur à 35k€',
      suffix: { title: 'E' },
    },
  ];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor, injector);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
